export default __webpack_public_path__ + "static/media/Group-6.4dee738f.png";